import React , { useState, useEffect } from 'react';
import { Layout, Stat, Card, Link, Jumbotron } from '@components'
import { Pool } from '@archetypes'
import assetController from '@app/App.Controller'

const Swap = () => {

	const { perlinx } = assetController
	const [ stats, setStats ] = useState()

	useEffect(() => {
		const sub =  perlinx.state.subscribe('stats', setStats, true)
		return () => sub.unsubscribe()
	}, []) // eslint-disable-line

	return (
		<Layout>
			<Layout.Main>
				<Jumbotron
					title="Swap tokens"
					navs={<Link.Dashboard />}
				>
					<Stat title='Total Volume Traded'>
						${(Number(stats?.volume) || 0).toLocaleString()}
					</Stat>
				</Jumbotron>
				<Pool.Exchange />
			</Layout.Main>
		</Layout>
	)
}

export default Swap